'use client';

import React from 'react'
import Image from '@src/components/atoms/safe-image';

// Assets
import Century21 from '@public/png/century-21-black-1.png';

// Components
import {
  DescriptionDekstop,
  DescriptionMobile,
  ImageDekstop,
  ImageMobile
} from "./_components"

const AboutCenturyIndonesia = () => {
  return (
    <div className='main-wrapper py-[104px] bg-white-3 
    dd-lg:py-[80px]'>
      <div className='content-wrapper flex flex-col items-center justify-center dd-lg:items-start'>

        <div className='flex items-end mb-[40px] 
        dd-lg:block'>
          <Image
            src={Century21}
            alt='CENTURY 21'
            width="auto"
            height="auto"
            className='w-[500px] h-[56px] object-contain mr-6 
            dd-xl:w-[357px] dd-xl:h-[40px] 
            dd-lg:mb-[27px] dd-lg:mr-0'
          />
          <p className='mb-2 text-[40px] text-black-3 font-typold-extended-medium leading-[40%] tracking-[0.16px] 
          dd-xl:text-[32px] dd-xl:mb-[5px]'>Indonesia</p>
        </div>
        <DescriptionDekstop />
        <DescriptionMobile />

        <ImageDekstop />
        <ImageMobile />
      </div>
    </div>
  )
}

export default AboutCenturyIndonesia